import ObjectModelProperty from "../../../common/models/objectModelProperties/objectModelProperty";

export default {
  props: {
    objectModelProperty: {
      type: Object as () => ObjectModelProperty,
      required: true,
    },
  },
}